import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import TownPage from "@/pages/TownPage";
import AllReviews from "@/pages/AllReviews";
import About from "@/pages/About";
import VenuePage from "@/pages/VenuePage";
import NotFound from "@/pages/NotFound";
import { TOWNS } from "@/data/site";
import { LiveStatsProvider } from "@/lib/liveStats";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LiveStatsProvider>
          <ScrollToTop />
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/reviews" element={<AllReviews />} />
              <Route path="/about" element={<About />} />
              {TOWNS.map((t) => (
                <Route
                  key={t.slug}
                  path={`/wedding-videographer-${t.slug}`}
                  element={<TownPage />}
                />
              ))}
              <Route path="/venues/:slug" element={<VenuePage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </LiveStatsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
